import React from 'react';
import GeckoDate from 'services/gecko-date';
import './MessageDate.scss';

const MessageDate = ({ received_at }) => {
  const receivedAt = new GeckoDate(received_at);
  const oneDayInSeconds = 86400;
  const moreThan1DayAgo =
    new GeckoDate().format('X') - receivedAt.format('X') > oneDayInSeconds;
  const received_at_text = moreThan1DayAgo
    ? receivedAt.SHORT_TIME
    : receivedAt.moment.fromNow();

  return <span className="MessageDate"> {received_at_text} </span>;
};

export default MessageDate;
